import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import "../Pages/Privacy.css";
import { Helmet } from "react-helmet";

export default function Privacy() {
  return (
    <>
  <Helmet>
  <title>Privacy Policy | Sri Rajalakshmi Travels</title>
  <meta name="robots" content="noindex, nofollow" />
  <link rel="canonical" href="https://srirajalakshmitravels.in/privacy" />

  {/* Travel Agency Schema */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "TravelAgency",
      name: "Sri Rajalakshmi Travels",
      image: "https://srirajalakshmitravels.com/static/media/SRILOGO.538e1e7c6643833d5ce3.png",
      url: "https://srirajalakshmitravels.in",
      telephone: "+91 90952 23243",
      address: {
        "@type": "PostalAddress",
        streetAddress: "12/4 Main Road",
        addressLocality: "Aruppukottai",
        addressRegion: "Tamil Nadu",
        postalCode: "626101",
        addressCountry: "IN"
      },
      openingHours: "Mo-Su 00:00-23:59",
      priceRange: "₹₹",
      sameAs: [
        "https://www.facebook.com/",
        "https://www.instagram.com/"
      ]
    })}
  </script>

  {/* Service Schema */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      serviceType: "Van Rental, Car Rental, Tourist Vehicle Booking",
      provider: {
        "@type": "TravelAgency",
        name: "Sri Rajalakshmi Travels"
      },
      areaServed: "Aruppukottai, Virudhunagar",
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: "Travel Services",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: { "@type": "Service", name: "Van Rental in Aruppukottai" }
          },
          {
            "@type": "Offer",
            itemOffered: { "@type": "Service", name: "Car Rental in Aruppukottai" }
          },
          {
            "@type": "Offer",
            itemOffered: { "@type": "Service", name: "Tour Package Booking" }
          }
        ]
      }
    })}
  </script>

</Helmet>

      <Navbar />

      <section className="privacy-section" data-aos="fade-up">

        <h1 className="privacy-title">Privacy Policy</h1>
        <p className="privacy-sub">
          This Privacy Policy explains how SRI RAJALAKSHMI TOURS & TRAVELS
          collects, uses, and protects your personal information.
        </p>

        <div className="privacy-content">

          <div className="privacy-box" data-aos="fade-up">
            <h2>1. Information We Collect</h2>
            <p>We may collect the following details from customers:</p>
            <ul>
              <li>✔ Name</li>
              <li>✔ Phone Number</li>
              <li>✔ WhatsApp Number</li>
              <li>✔ Travel Location & Date</li>
              <li>✔ Service Requirements</li>
              <li>✔ Website usage data (IP address, browser type)</li>
            </ul>
          </div>

          <div className="privacy-box" data-aos="fade-up">
            <h2>2. How We Use Your Information</h2>
            <ul>
              <li>✔ To confirm bookings and provide travel service</li>
              <li>✔ For customer support and timely communication</li>
              <li>✔ To improve our service quality</li>
              <li>✔ To prevent fraud or misuse</li>
            </ul>
          </div>

          <div className="privacy-box" data-aos="fade-up">
            <h2>3. Data Protection</h2>
            <p>
              We follow strict safety measures to protect your information.
              Your data is stored securely and accessed only by authorized staff.
            </p>
          </div>

          <div className="privacy-box" data-aos="fade-up">
            <h2>4. Sharing of Information</h2>
            <p>
              We DO NOT sell, share, or transfer your personal information to
              third parties. Your data is used only for service purposes.
            </p>
          </div>

          <div className="privacy-box" data-aos="fade-up">
            <h2>5. Cookies & Website Tracking</h2>
            <p>
              We may use cookies to improve website performance and user experience.
              These do not store personal data.
            </p>
          </div>

          <div className="privacy-box" data-aos="fade-up">
            <h2>6. Your Rights</h2>
            <ul>
              <li>✔ Access your stored data</li>
              <li>✔ Request correction of your details</li>
              <li>✔ Request deletion of your personal information</li>
            </ul>
          </div>

          <div className="privacy-box" data-aos="fade-up">
            <h2>7. Contact Information</h2>
            <p>For privacy concerns, contact:</p>
            <p><strong>SRI RAJALAKSHMI TOURS & TRAVELS</strong></p>
            <p>📞 +91 90952 23243</p>
            <p>📧 srirajalakshmitravels@gmail.com</p>
          </div>

        </div>

      </section>

      <Footer />
    </>
  );
}
